import { Navigate, Route, Routes } from 'react-router-dom';
import { ProtectedRoute } from '../components/ProtectedRoute.js';
import { AdminCreateRequestPage } from '../pages/AdminCreateRequestPage.js';
import { AdminDashboardPage } from '../pages/AdminDashboardPage.js';
import { AdminHomePage } from '../pages/AdminHomePage.js';
import { AdminLoginPage } from '../pages/AdminLoginPage.js';
import { AdminRequestDetailPage } from '../pages/AdminRequestDetailPage.js';
import { AdminResponseDetailPage } from '../pages/AdminResponseDetailPage.js';
import { InvoiceEditorPage } from '../pages/InvoiceEditorPage.js';
import { InvoiceListPage } from '../pages/InvoiceListPage.js';
import { FeedbackFormPage } from '../pages/FeedbackFormPage.js';
import { HomePage } from '../pages/HomePage.js';
import { NotFoundPage } from '../pages/NotFoundPage.js';
import { PrivacyPage } from '../pages/PrivacyPage.js';
import { AdminCreateStoryPage } from '../pages/AdminCreateStoryPage.js';
import { AdminStoriesPage } from '../pages/AdminStoriesPage.js';
import { AdminStoryDetailPage } from '../pages/AdminStoryDetailPage.js';
import { PublicInvoicePage } from '../pages/PublicInvoicePage.js';
import { PublicStoryPage } from '../pages/PublicStoryPage.js';

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/f/:token" element={<FeedbackFormPage />} />
      <Route path="/i/:accessToken" element={<PublicInvoicePage />} />
      <Route path="/share/:token" element={<PublicStoryPage />} />
      <Route path="/admin/login" element={<AdminLoginPage />} />
      <Route
        path="/admin"
        element={
          <ProtectedRoute>
            <AdminDashboardPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/requests"
        element={
          <ProtectedRoute>
            <AdminHomePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/requests/new"
        element={
          <ProtectedRoute>
            <AdminCreateRequestPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/requests/:requestId"
        element={
          <ProtectedRoute>
            <AdminRequestDetailPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/responses/:responseId"
        element={
          <ProtectedRoute>
            <AdminResponseDetailPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/invoices"
        element={
          <ProtectedRoute>
            <InvoiceListPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/invoices/new"
        element={
          <ProtectedRoute>
            <InvoiceEditorPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/invoices/:invoiceId"
        element={
          <ProtectedRoute>
            <InvoiceEditorPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/stories"
        element={
          <ProtectedRoute>
            <AdminStoriesPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/stories/new"
        element={
          <ProtectedRoute>
            <AdminCreateStoryPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/stories/:storyId"
        element={
          <ProtectedRoute>
            <AdminStoryDetailPage />
          </ProtectedRoute>
        }
      />
      <Route path="/admin/*" element={<Navigate to="/admin" replace />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
